// IndexedDB based storage for audio/video files (large blobs)
// localStorage for topic structure (smaller data)

const DB_NAME = 'karmkand_bhaskar_db';
const DB_VERSION = 1;
const MEDIA_STORE = 'media_files';
const TOPICS_KEY = 'kb_topics_v2';  // bumped version to invalidate old structure
const SETTINGS_KEY = 'kb_settings';

let dbPromise = null;

function openDB() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(MEDIA_STORE)) {
        db.createObjectStore(MEDIA_STORE);
      }
    };
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror = (e) => reject(e);
  });
  return dbPromise;
}

export async function saveMedia(key, blob) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(MEDIA_STORE, 'readwrite');
    const store = tx.objectStore(MEDIA_STORE);
    const req = store.put(blob, key);
    req.onsuccess = () => resolve(true);
    req.onerror = (e) => reject(e);
  });
}

export async function getMedia(key) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(MEDIA_STORE, 'readonly');
    const store = tx.objectStore(MEDIA_STORE);
    const req = store.get(key);
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = (e) => reject(e);
  });
}

export async function deleteMedia(key) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(MEDIA_STORE, 'readwrite');
    const store = tx.objectStore(MEDIA_STORE);
    const req = store.delete(key);
    req.onsuccess = () => resolve(true);
    req.onerror = (e) => reject(e);
  });
}

export async function getMediaURL(key) {
  if (!key) return '';
  const blob = await getMedia(key);
  if (!blob) return '';
  return URL.createObjectURL(blob);
}

// Topics persistence
export function loadTopics(defaultTopics) {
  try {
    const saved = localStorage.getItem(TOPICS_KEY);
    if (saved) return JSON.parse(saved);
  } catch (e) {
    console.error('Failed to load topics', e);
  }
  return defaultTopics;
}

export function saveTopics(topics) {
  try {
    localStorage.setItem(TOPICS_KEY, JSON.stringify(topics));
  } catch (e) {
    console.error('Failed to save topics', e);
  }
}

export function loadSettings() {
  try {
    const saved = localStorage.getItem(SETTINGS_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        speed: 1.0,
        theme: 'saffron',
        fontSize: 18,
        gayatriRepeat: 11,
        sanskarInsertAfter: 'm-y6',
        ...parsed,
      };
    }
  } catch (e) {}
  return { speed: 1.0, theme: 'saffron', fontSize: 18, gayatriRepeat: 11, sanskarInsertAfter: 'm-y6' };
}

export function saveSettings(settings) {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch (e) {}
}

export function resetAll() {
  localStorage.removeItem(TOPICS_KEY);
  localStorage.removeItem(SETTINGS_KEY);
}
